<template>
    <BaseModal name="youtube-video" :adaptive="true" :width="'100%'" :max-width="560" :height="'auto'"
               :scrollable="true"
               @before-open="beforeOpen" :no-padding="true">
        <div class="tw-p-14 tw-text-center tw-text-infinity-tertiary-text" v-if="error">
            Oops! Failed to load the YouTube URL :(
        </div>
        <template v-if="!error">
            <div class="tw-relative" style="height: 315px;" v-if="!loaded">
                <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                    <base-infinity-loading class="tw-w-20" />
                </div>
            </div>
            <iframe @load="loaded = true"
                    v-if="url"
                    :width="loaded ? '100%' : '0'"
                    :height="loaded ? '315' : '0'"
                    class="tw-rounded-xl"
                    :src="`${url}?&autoplay=1`"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
            </iframe>
        </template>
    </BaseModal>
</template>
<script>
import BaseModal from "../base/base-modal.vue";
import BaseInfinityLoading from "../base/base-infinity-loading";

export default {
    components: {
        BaseInfinityLoading,
        BaseModal
    },
    data() {
        return {
            loaded: false,
            url: null,
            error: null
        };
    },
    methods: {
        beforeOpen(event) {
            this.error = null;
            this.loaded = false;
            this.url = null;
            this.loadUrl(event.params.url);
        },
        async loadUrl(rawUrl) {
            try {
                const response = await this.$http.get(`https://www.youtube.com/oembed?url=${rawUrl}&format=json`);
                const videoEmbedId = /(?<=embed\/)(\w+)(?=\?feature)/g.exec(response.data.html)?.[0];
                if (videoEmbedId) {
                    this.url = `https://www.youtube.com/embed/${videoEmbedId}`
                } else {
                    this.error = true;
                }
            } catch (e) {
                console.error(e)
                this.error = true;
            }
        }
    }
};
</script>
